import { CampaignResponse, Result } from '@models/campaign';
import { ItemResponse } from '@models/order/items/response';
import {
    ApplyContext,
    ConflictItem,
    FetchContext,
    FetchParams,
    OrderContext,
    SubmitError,
    ValidationError,
} from '../types';
import { CampaignStrategy } from './campaign-strategy';

// NOTIFICACAO não tem efeito no front (só notificação backend).
// Strategy no-op explícita para fechar a tabela de tipos.
export class NotificacaoStrategy implements CampaignStrategy {
    readonly tipo = 'NOTIFICACAO' as const;

    isAvailableForOrder(
        _campaign: CampaignResponse,
        _context: OrderContext,
    ): boolean {
        return true;
    }

    validateEligibility(): ValidationError[] {
        return [];
    }

    detectConflicts(): ConflictItem[] {
        return [];
    }

    onEnable(
        _campaign: CampaignResponse,
        orderItems: ItemResponse[],
        _context: ApplyContext,
    ): ItemResponse[] {
        return orderItems;
    }

    applyResultToItem(
        item: ItemResponse,
        _result: Result,
        _campaign: CampaignResponse,
        _context: ApplyContext,
    ): ItemResponse {
        return item;
    }

    recalculateOnQuantityChange(
        _campaign: CampaignResponse,
        orderItems: ItemResponse[],
        _context: ApplyContext,
    ): ItemResponse[] {
        return orderItems;
    }

    validateForSubmit(): SubmitError[] {
        return [];
    }

    requiresExtraFetchParams(
        _campaign: CampaignResponse,
        _context: FetchContext,
    ): Partial<FetchParams> {
        return {};
    }

    acceptsPaymentCondition(_paymentConditionId: string): boolean {
        return true;
    }
}
